<script setup>
import AppCard from './layouts/AppCard.vue';
import AppPreviewCard from './layouts/AppPreviewCard.vue';

const props = defineProps({
    milestoneId: Number,
    title: String,
    shortDescription: String,
    longDescription: String,
    activities: Array,
    checklistItems: Array,
})

const firstPar = "Each child is unique, and his/her development varies slightly from child to child. This list will give you a general idea of what your child will be able to do at certain age."

</script>
<template>
    <AppCard :header="props.title" :body="firstPar" :id="`milestone-${props.milestoneId}-details`">
        <ul class="list-disc list-inside  mt-2">
            <li v-for="item in props.checklistItems" class="text-sm text-black text-left  space-y-1 ">
                {{ item.attributes.title }}
            </li>
        </ul>
    </AppCard>
    <AppCard :header="`${props.title} Activities`" :body="`${props.shortDescription}. The below activites can help your child build their skills.`" class="mb-8">
        <ol class="max-w-md md:max-w-none space-y-1 text-black text-sm list-disc list-inside text-left">
            <li v-for="activity in props.activities">{{ activity.attributes.title }}</li>
        </ol>
    </AppCard>
</template>